<div class="partner-request-model card flex justify-content-center">
  <p-dialog
    [header]="type() + ' ' + 'Response'"
    [modal]="true"
    (onHide)="close()"
    [visible]="visible() ?? false"
    [style]="{ width: '25rem' }">
    <div class="d-flex flex-column gap-2 w-100 justify-content-center p-2">
        <div class="d-flex flex-column">
            <label>Admin Notes</label>
            <textarea [autoResize]="false" [maxlength]="50" pInputTextarea [(ngModel)]="messageText">
            </textarea>
        </div>
      <div class="d-flex flex-row-reverse gap-2">
        <p-button class="close-btn btn btn-secondary" (onClick)="close()">Cancel</p-button>
        <p-button class="response-btn btn" [class]="(type() === 'Accept' ? 'btn-primary':'btn-danger')" (onClick)="sendResponse()">{{type()}}</p-button>
      </div>
    </div>
  </p-dialog>
</div>
